import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

const FeatureDescription = (props) => {

  const {feature, intl, fabricatorData, brief, className, textLength} = props;

  let desc = "";
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
    if (intl.locale === "fr-FR" && intl.messages["transDoc.description_FR." + feature.dbFeature.sharedFeatureName]) {
      desc = intl.formatMessage({id: "transDoc.description_FR." + feature.dbFeature.sharedFeatureName})
    } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customTranslateDescription_PL." + feature.dbFeature.sharedFeatureName]) {
      desc = intl.formatMessage({id: "transDoc.customTranslateDescription_PL."  + feature.dbFeature.sharedFeatureName})
    } else {
      desc = feature.dbFeature.description;
    }
  } else {
    desc = feature.dbFeature.description;
  }

  if (!desc) {
    return null
  }

  if (textLength && desc.length > textLength) {
    desc = desc.substring(0, textLength) + "..."
  } else if (brief && desc && desc.length > 200) {
    desc = desc.substring(0, 200) + "..."
  }

  return <p className={className || "look-description"} dangerouslySetInnerHTML={{__html: desc}}/>
};

FeatureDescription.propTypes = {
  feature: PropTypes.object.isRequired,
  className: PropTypes.string,
  brief: PropTypes.bool,
  textLength: PropTypes.number,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureDescription)
)

